<template>
  <div class="row">
    <div class="col-md-12 pad-to-5">
      <p></p>
      <kds-form :route="route"></kds-form>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import KdsForm from './KdsForm.vue'

  Vue.use(Select)

  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      KdsForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
      }
    },
    methods: {
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Screens/Kds/KdsAdd.vue